var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUcWhiteBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#3D71B2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.5,596.8c-8.1-0.1-29.6-0.2-46.2-13c-14.6-11.2-18.8-27.8-18.8-43.6V452v-15.8v-58.4 c0-4.8,3.9-8.6,8.6-8.6h20.5c5.3,0,8.4-6,5.4-10.3l-73.8-105.5c-2.6-3.7-8.1-3.7-10.7,0l-73.8,105.5c-3,4.3,0.1,10.3,5.4,10.3h20.3 c4.8,0,8.6,3.9,8.6,8.6v87.5v23.6v50.9c0,10.4,1,20.8,3.5,31.1c2.2,9.3,5.6,18.3,10.5,26.9c14,24.9,42.2,36.6,74.8,36.6 c4.6,0,17.3,0,32.6-4c21.6-5.6,37.3-16.1,47.9-25.2c3.2-2.8,1.2-8.1-3.1-8.2L439.5,596.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M795.5,437.6c-11.4-22.7-26.8-40.2-46.4-52.4c-19.6-12.2-41.4-18.3-65.5-18.3c-20.6,0-38.6,4.2-54,12.6 c-15.4,8.4-27.4,19.4-36.1,33l0-34.8c0-3.6-2.9-6.6-6.6-6.6h-76.5c-3.6,0-6.6,2.9-6.6,6.6v138c-1.8,50-28.2,97.7-74,120.1 c-18.3,9-35.8,12.1-49.5,12.9c-4.9,0.3-5.9,7.1-1.3,8.9c8,3.1,17.2,6,27.6,8.1c45.9,9.3,83-3.5,96.7-9.1c0.1-0.1,0.3-0.1,0.4-0.2 v139.8c0,3.6,2.9,6.6,6.6,6.6H587c3.6,0,6.6-2.9,6.6-6.6V622.8c1.8,2.4,3.5,4.6,5.3,6.6c8.1,10.1,18.4,18.7,31.2,25.6 c15.5,8.4,33.4,12.6,53.7,12.6c24.1,0,45.9-6.2,65.5-18.6c19.6-12.4,35-30.1,46.4-52.9c11.3-22.9,17-49.3,17-79.4 C812.5,486.7,806.8,460.3,795.5,437.6z M702.5,569.9c-12.6,13.1-27.8,19.6-45.6,19.6c-17.8,0-32.9-6.4-45.3-19.4 c-12.4-12.9-18.6-30.5-18.6-52.9c0-22.3,6.2-40,18.6-52.9c12.4-12.9,27.5-19.4,45.3-19.4c18.1,0,33.4,6.4,45.8,19.1 c12.4,12.7,18.6,30.3,18.6,52.6C721.3,539.1,715,556.8,702.5,569.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M820.3,689.8c-65,101.5-180.4,167.7-310.6,162.9C326.2,846.1,177.3,697.5,170.2,514 C162.4,313,323.6,147,522.9,147c118.6,0,223.7,58.8,287.7,148.8c1.2,1.7,3.2,2.8,5.3,2.8h85.8c5,0,8.1-5.4,5.7-9.8 C832.7,153.2,688.4,61.1,522.9,61.1C280.9,61.1,84,258,84,500c0,242,196.9,438.9,438.9,438.9c171.4,0,320.2-98.8,392.4-242.5 c2.2-4.4-0.9-9.6-5.8-9.6h-83.6C823.6,686.8,821.5,687.9,820.3,689.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUcWhiteBlue);
export default __webpack_public_path__ + "static/media/logo_uc_white_blue.74d5ff650c7ccba3153d349976bf3ec5.svg";
export { ForwardRef as ReactComponent };